import styled from "styled-components";

const Description = styled.div`
  // Same as the Cloud Icon.
  color: #cbcbcb;
  font-size: 10px;
  width: calc(100% - 10px);
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 12px;
`;

export default Description;
